import React, { Fragment, useEffect, useState } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import FsLightbox from 'fslightbox-react';
import Splide from '@splidejs/splide';

const loadVerticalSlider = () => {
    const splideElPdp = document.querySelectorAll('.product-detail-thumbnails .splide');
    if (splideElPdp.length > 0) {
        new Splide('.product-detail-thumbnails .splide',
            {
                direction: 'ttb',
                height: '365px',
                perPage: 3,
                perMove: 1,
                gap: '10px',
                rewind: true,
                type: 'slide',
            }).mount();
    }
}

const LightboxImages = (props) => {
    const [toggler, setToggler] = useState(false);
    const [sourceIndex, setSourceIndex] = useState(0);
    const [mainImageIndex, setMainImageIndex] = useState(0);
    const onClickThumbnail = (index) => {
        setMainImageIndex(index);
        const imageEl = document.querySelector(".splide-image.is-clicked");
        if (imageEl) {
            imageEl.classList.remove("is-clicked");
        }
        const targetEl = document.getElementById("splidePdp-slide0" + (index + 1))
        if (targetEl) {
            targetEl.classList.add("is-clicked");
        }
    };

    const onClickMain = (index) => {
        setToggler(!toggler);
        setSourceIndex(index);
        setMainImageIndex(index);
    };

    useEffect(() => {
        loadVerticalSlider();
    }, []);

    if (props.images && props.images.length > 0) {
        const showExplodedClass = props.images[mainImageIndex].isExploded ? "show-exploded-view" : "";
        const mainImageHtml = props.images[mainImageIndex].videoLink ? "<span><a href=" + props.images[mainImageIndex].videoLink + ">" + props.images[mainImageIndex].html + "</a></span>" : props.images[mainImageIndex].html
        const mainImageLink = props.images[mainImageIndex].videoLink ? props.images[mainImageIndex].videoLink : props.images[mainImageIndex].src

        return (
            <Fragment>
                <div className="row product-images">
                    <div className="medium-9 columns">
                        <figure className={`product-detail__image-container ${showExplodedClass}`}>
                            <a
                                data-src={mainImageLink}
                                href="#"
                                itemProp="url"
                                onClick={(e) => {
                                    if (!props.images[mainImageIndex].videoLink) {
                                        e.preventDefault();
                                        onClickMain(mainImageIndex);
                                    }
                                }}
                                className="product-image"
                                rel="nofollow"
                                dangerouslySetInnerHTML={{
                                    __html: mainImageHtml,
                                }}
                            ></a>
                        </figure>
                    </div>
                    <div className="medium-3 columns product-detail-thumbnails">
                        <div className="thumbnail-image-container splide" id="splidePdp">
                            <div className="splide__track">
                                <ul className="splide__list">
                                    {props.images.map((image, index) => {
                                        let isFirstIndex = index === 0 ? "is-clicked" : "";
                                        const thumbnailHtml = image.isExploded ? props.sparepartIcon[0].html : image.videoLink ? "<img class='video-icon'/>" : props.images[index].html;
                                        return (
                                            <li className={`splide__slide splide-image ${isFirstIndex}`} key={index}>
                                                <div className="product-detail__image-container columns small-12" key={index}>
                                                    <a
                                                        data-src={image.src}
                                                        href="#"
                                                        itemProp="url"
                                                        className="product-image"
                                                        rel="nofollow"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            onClickThumbnail(index);
                                                        }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: thumbnailHtml
                                                        }}
                                                    ></a>
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <FsLightbox
                    toggler={toggler}
                    sourceIndex={sourceIndex}
                    loadOnlyCurrentSource={true}
                    sources={props.images.map((value, index) => (<img src={value.src} key={index} />))}
                />
            </Fragment>
            );
    }
    else {
        return (<Fragment />);
    }
};

export default LightboxImages;
